import { createAppI18n, sharedTranslations, type TKeyOf } from '@repo/i18n'
import { siteTranslations } from '@/routes/(public)/-translations/site-translations'
import { commonTranslations } from '@/translations/common-translations'

/**
 * App-owned i18n facade. The engine and the shared `shared` namespace (text
 * built into `@repo/ui` components) live in `@repo/i18n`; the app's own
 * `common` namespace and the public-site `site` namespace live here. App code
 * keeps importing from `@/lib/i18n`.
 */
const resources = {
	en: {
		common: commonTranslations.en,
		shared: sharedTranslations.en,
		site: siteTranslations.en
	},
	it: {
		common: commonTranslations.it,
		shared: sharedTranslations.it,
		site: siteTranslations.it
	}
} as const

const appI18n = createAppI18n(resources, { defaultNS: 'common' })

export const { useTranslation, Trans, translateApp } = appI18n

/**
 * All translation keys with namespace prefix (e.g.
 * `shared:http_errors.default`).
 */
export type TKey = TKeyOf<(typeof resources)['en']>

const i18n = appI18n.i18n

export default i18n

export {
	APP_LANGUAGES,
	type AppLanguage,
	type AppLanguageCode,
	changeAppLanguage,
	DEFAULT_LANGUAGE,
	detectAppLanguageFromRequest,
	getInitialAppLanguage,
	isAppLanguageCode,
	resolveAppLanguageCode,
	syncAppLanguage,
	translateKey
} from '@repo/i18n'
